import { render, staticRenderFns } from "./ServiceJoinProcess.vue?vue&type=template&id=5d38a70d&scoped=true&"
import script from "./ServiceJoinProcess.vue?vue&type=script&lang=js&"
export * from "./ServiceJoinProcess.vue?vue&type=script&lang=js&"
import style0 from "./ServiceJoinProcess.vue?vue&type=style&index=0&id=5d38a70d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d38a70d",
  null
  
)

export default component.exports